<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>
    <a-modal v-model="geoshow"  >
      <MapGeo @mapgeoEvent="SaveMapEvent"  :keyWord="address"></MapGeo>
    </a-modal>
    <a-card class="all-card-style ">

      <a-form-model :model="scene"  :rules="sceneFormRules" ref="scene"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" >
        <a-row>
        <a-col :span="8">
          <a-form-model-item label="类型"  class="ant-form-item2 " >
            <a-select
              placeholder=""
              v-model="scene.iTypeID"  @change="iTypeIDSelectFun"    class="ant-form-item3 "
            >

              <a-select-option value="2" >
                场景图2
              </a-select-option>
              <a-select-option value="3" >
                场景图3
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        </a-row>


        <a-row>
          <a-col :span="8">
            <a-form-model-item label="设备"  prop="cSceneCode"  class="ant-form-item2 " >
              <a-select v-model="sb1" @change="deviceGFJSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceGFJSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row  v-show="scene.iTypeID==1||scene.iTypeID==2||scene.iTypeID==3">
          <a-col :span="8">
            <a-form-model-item :label="scene.iTypeID==1?'鼓风机':scene.iTypeID==2?'水泵1':'水泵'"  prop="cSceneCode"  class="ant-form-item2 " >
           <!--   <a-select v-model="sb1" @change="deviceGFJSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceGFJSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>-->
              <a-select v-model="zxq1" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerGFJSelectItems" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==1||scene.iTypeID==2">
          <a-col :span="8">
            <a-form-model-item :label="scene.iTypeID==1?'机械过滤器':'水泵2'"  prop="cSceneCode"  class="ant-form-item2 " >
           <!--   <a-select v-model="sb2" @change="deviceJXGLQSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceJXGLQSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>-->
              <a-select v-model="zxq2" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerJXGLSelectItems" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==1||scene.iTypeID==2">
          <a-col :span="8">
            <a-form-model-item  :label="scene.iTypeID==1?'水泵':'水泵3'"  prop="cSceneCode"  class="ant-form-item2 " >
            <!--  <a-select v-model="sb3" @change="deviceSBSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceSBSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>-->
              <a-select v-model="zxq3" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSBSelectItems" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==1||scene.iTypeID==2">
          <a-col :span="8">
            <a-form-model-item  :label="scene.iTypeID==1?'紫外线':'水泵4'"  prop="cSceneCode"  class="ant-form-item2 " >
             <!-- <a-select v-model="sb5" @change="deviceZWXSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceZWXSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>-->
              <a-select v-model="zxq5" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerZWXSelectItems" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>

        </a-form-model-item>

      </a-form-model>

<div v-show="iTypeIDSelectId==1">
  <img src="../../../img/smap1.png" style="width: 900px;" />

</div>

      <div v-show="iTypeIDSelectId==2">
        <img src="../../../img/smap2.png" style="width: 900px;" />

      </div>
      <div v-show="iTypeIDSelectId==3">
        <img src="../../../img/smap3.png" style="width: 900px;" />

      </div>
    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import MapGeo from '@/components/MapGeo'
  export default {
    name: 'sceneManagementForm',
    components: {
      TitleCard,
      MapGeo
    },
    data() {
      return {
        options:[],
        dfi:['110000','110100','110101'],
        sceneFormRules:{

        },
        titleMsg1: "设备管理",
        titleMsg2:'场地管理',
        titleMsg3:'场景图管理',
        titleMsg4:'新增',
        scene:{
          ID:"",
          cEntID:"",
          cPlatformID:"",
          cSceneTempID:"",
          cSceneCode:"",
          cSceneName:"",
          cAddress:"",
          cLatitude:"",
          cLongitude:"",
          cArea:"",
          cUnit:"",
          cVariety:"",
          cChargeUser:"",
          cChargeMoblie:"",
          cChargeEmail:"",
          iDelete:"",
          cCreateUserID:"",
          cCreateUserName:"",
          dCreateDate:"",
          cUpdateUserID:"",
          cUpdateUserName:"",
          Remark:""
        },
        cVarietyClass:"",
        unitList:[],
        varietyList:[],
        userList:[],
        varietyclassList:[],
        PlatformList:[],
        PlatformCurrent:{},
        address:"",
        deviceGFJSelectItems:[],
        deviceJXGLQSelectItems:[],
        deviceSBSelectItems:[],
        deviceSBOSelectItems:[],
        deviceZWXSelectItems:[],
        geoshow:false,
        controllerGFJSelectItems:[],
        controllerJXGLSelectItems:[],
        controllerSBSelectItems:[],
        controllerSBOSelectItems:[],
        controllerZWXSelectItems:[],
        sb1:'',
        zxq1:'',

        sb2:'',
        zxq2:'',

        sb3:'',
        zxq3:'',

        sb4:'',
        zxq4:'',

        sb5:'',
        zxq5:'',
        iTypeIDSelectId:-1,
        SceneInfoID:'',
      }
    },
    mounted () {
      let that=this;

      console.log('that.$route.params.ID',that.$route.params.ID);
      if (that.$route.params.ID){
        that.scene.SceneInfoID=that.$route.params.ID;
        that.SceneInfoID=that.$route.params.ID;
        that.HandleDetail();
      }
      try{   that.dfi=[ that.scene.cEntCountry+'', that.scene.cEntCity+'', that.scene.cEntArea+''];}catch (e) {

      }

      that.handleunit();
      that.handlusers();

      that.handlePageList();
      that.getDeviceIDSelectItems();
    },
    methods: {
      iTypeIDSelectFun(obj){
console.log('obj:::',obj);
        this.iTypeIDSelectId=obj;

      },
      async deviceGFJSelect(obj){
        console.log('obj::::::',obj);

//controllerGFJSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerGFJSelectItems=res.data.obj.list;
          that.controllerJXGLSelectItems=res.data.obj.list;
          that.controllerSBSelectItems=res.data.obj.list;
          that.controllerSBOSelectItems=res.data.obj.list;
          that.controllerZWXSelectItems=res.data.obj.list;
        }
      },
      async deviceJXGLQSelect(obj){
//controllerJXGLSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerJXGLSelectItems=res.data.obj.list;
        }
      },
      async deviceSBSelect(obj){
//controllerSBSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerSBSelectItems=res.data.obj.list;
        }
      },
      async deviceSBOSelect(obj){
//controllerSBOSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerSBOSelectItems=res.data.obj.list;
        }
      },
      async deviceZWXSelect(obj){
//controllerZWXSelectItems.
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerZWXSelectItems=res.data.obj.list;


        }
      },

      async getDeviceIDSelectItems(){
        let that=this;
        let res = await this.$http.post('WLWDevice/List', {
          cEntID:that.$store.getters.User.enterprise.ID,cSystemCode:'节水灌溉',
          sceneId: that.scene.ID
        });
        that.deviceGFJSelectItems = res.data.obj.list;
        that.deviceJXGLQSelectItems = res.data.obj.list;
        that.deviceSBSelectItems = res.data.obj.list;
        that.deviceSBOSelectItems = res.data.obj.list;
        that.deviceZWXSelectItems = res.data.obj.list;
      },

      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntSceneMap/FindBySceneInfoID/' + that.scene.SceneInfoID, null)

        if (res.data.code == "200") {
          that.scene = res.data.obj.data;
            that.  sb1=  that.scene .sb1;
          that.        zxq1=  that.scene.zxq1;

            that.    sb2 =that.scene.sb2;
            that.    zxq2 =that.scene.zxq2;

            that.     sb3 =that.scene.sb3 ;
            that.     zxq3 =that.scene.zxq3;

            that.    sb4 =that.scene.sb4;
            that.     zxq4=  that.scene.zxq4;

            that.    sb5 =that.scene.sb5 ;
            that.    zxq5=that.scene.zxq5;
            that.     iTypeIDSelectId=that.scene.iTypeID;


          that. deviceGFJSelect(that.sb1);
          that.  deviceJXGLQSelect(that.sb2);
          that.  deviceSBSelect(that.sb3);
          that. deviceSBOSelect(that.sb4);
          that. deviceZWXSelect(that.sb5);

        } else {

        }
      },
      onChange(_value){
        console.log('_value',_value);
        this.scene    .cEntCountry= _value[0];
        this.scene    .cEntCity=  _value[1];
        this.scene    .cEntArea=  _value[2];
      },
      SaveMapEvent(data){
        let that=this;
        that.scene.cLongitude=data.longitude;
        that.scene.cLatitude=data.latitude;
        that.geoshow=false;
      },
      changeCharge(){
        let that=this;
        let u= that.userList.filter(s=>s.ID==that.scene.cChargeUser)[0];
        if(u){
          that.scene.cChargeUser=u.cUserName;
          that.scene.cChargeMoblie=u.cMobile;
          that.scene.cChargeEmail=u.cEmail
        }

      },
      async handlePageList(){

      },
      //单位
      async handleunit(){


      },
      async handleclasschange(){

      },
      //节水灌溉
      async handleariea(){


      },
      //获取用户列表
      async handlusers(){



      },

      toMapPage(record){
        let that=this;
        that.geoshow=true;

        that.address=record;
      },

      async SaveForms () {
        let that = this;
        let form=that.$refs['scene'];
        that.scene.sb1=   that.sb1;
        that.scene.zxq1=   that.zxq1;
        that.scene.sb2=   that.sb2;
        that.scene.zxq2=   that.zxq2;
        that.scene.sb3=   that.sb3;
        that.scene.zxq3=   that.zxq3;
        that.scene.sb4=   that.sb4;
        that.scene.zxq4=   that.zxq4;
        that.scene.sb5=   that.sb5;
        that.scene.zxq5=   that.zxq5;
        that.scene.iTypeID=   that.iTypeIDSelectId;
that.scene.SceneInfoID=   that.SceneInfoID;
if(that.scene.iTypeID==3){
  that.scene.sb2=   '';
  that.scene.zxq2=  '';
  that.scene.sb3=   '';
  that.scene.zxq3=  '';
  that.scene.sb4=  '';
  that.scene.zxq4=  '';
  that.scene.sb5=  '';
  that.scene.zxq5= '';

}
        form.validate(async valid => {

          if (valid) {
            let res = await that.$http.post('EntSceneMap/Save', that.scene)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }

  }
</script>


